import { COMPONENT_NAME_PREFIX } from '../constants';
import { BACKDROP_CONSTANTS } from '../backdrop';
var elementName = COMPONENT_NAME_PREFIX + "dialog";
var classes = {
    ANIMATING: 'tyl-dialog--animating',
    OPEN: 'tyl-dialog--open',
    ACTION_BUTTON: 'tyl-dialog__action__button',
    BUTTON_TEXT: 'tyl-button__text',
    SCROLLABLE: 'tyl-dialog--scrollable',
    FULLSCREEN: 'tyl-dialog--fullscreen',
    MOVEABLE: 'tyl-dialog--moveable'
};
var attributes = {
    BACKDROP_CLOSE: 'backdrop-close',
    ESCAPE_CLOSE: 'escape-close',
    FULLSCREEN: 'fullscreen',
    POSITION_TYPE: 'position-type',
    POSITION_X: 'position-x',
    POSITION_Y: 'position-y',
    MOVEABLE: 'moveable',
    MOVE_TARGET: 'move-target',
    OPEN: 'tcw-dialog-open',
    INITIAL_FOCUS: 'tcw-dialog-focus',
    DFEAULT_MOVE_TARGET: 'tcw-dialog-move-target'
};
var selectors = {
    CONTAINER: '.tyl-dialog',
    SURFACE: '.tyl-dialog__surface',
    BACKDROP: BACKDROP_CONSTANTS.elementName,
    INITIAL_FOCUS: "[" + attributes.INITIAL_FOCUS + "]",
    DFEAULT_MOVE_TARGET: "[" + attributes.DFEAULT_MOVE_TARGET + "]",
    CONTENT: '.tyl-dialog__body'
};
var events = {
    BEFORE_CLOSE: elementName + "-before-close",
    OPEN: elementName + "-open",
    CLOSE: elementName + "-close",
    READY: elementName + "-ready",
    MOVE_START: elementName + "-move-start",
    MOVED: elementName + "-move",
    MOVE_END: elementName + "-move-end"
};
var numbers = {
    ANIMATION_DURATION: 150,
    BACKDROP_MAX_OPACITY: 0.3
};
export var DIALOG_CONSTANTS = {
    elementName: elementName,
    classes: classes,
    selectors: selectors,
    attributes: attributes,
    events: events,
    numbers: numbers
};
